<template>
  <v-row
    align="center"
    justify="center"
  >
    <v-col mb4 xs12 sm4 md1 class="text-center">
      <h1 class="display-1 font-weight-thin" style="width: 100%; margin-top: 12vh; margin-bottom: 2vh;font-size: calc(20px + 1vh)">
        Você está com problemas, deseja limpar o cache do navegador?
      </h1>
      <v-btn color="primary" @click="eraseData()">
        Apagar
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>

export default {
  async mounted(){
  },
  methods: {
    eraseData() {
      localStorage.clear();
      location.reload();
    }
  }
}

</script>
